<template>
    <div>
     <b-modal 
         v-model="this.open" 
         stacking
         centered
         no-close-on-esc
         no-close-on-backdrop
         hide-footer
         hide-header
         size="lg"
     >
         <div>
            <div class="text-center" v-bind:style="{ position: 'relative' }">
                <h1 v-if="this.isExceedCutOffDate" v-bind:style="{ color: 'red', fontWeight: 'bold' }">ไม่สามารถสร้างรายการได้</h1>
                <h1 v-if="!this.isExceedCutOffDate" v-bind:style="{ color: this.$THEME.backgroundColor, fontWeight: 'bold' }">ยืนยันข้อมูลเปิดใช้งาน Wallet</h1>
                <button v-if="!this.isExceedCutOffDate" @click="closeModal" v-bind:style="{ border: 'none', position: 'absolute', top: 0, right: 0, background: 'transparent' }">
                    <Icon icon="material-symbols:close" class="close" v-bind:style="{ fontSize: '16px' }" />
                </button>
            </div>
            <div v-if="this.isExceedCutOffDate">
                <div class="mb-4 text-center">
                    <p class="text-sm m-0">
                        เนื่องจากคุณยังไม่ยืนยันตัวตนเพื่อเปิดใช้งานวอลเล็ท
                    </p>
                    <p class="text-sm m-0">กรุณาตรวจสอบอีเมลที่ระบุ และกดปุ่ม <span v-bind:style="{ color: this.$THEME.backgroundColor }">"ยืนยัน"</span> ด้านล่าง</p>
                    <p class="text-sm m-0 mt-4">โดยหลังจากยืนยันสำเร็จแล้วจะสามารถใช้งานต่อได้ทันที</p>
                </div>
            </div>


             <div v-if="!this.isExceedCutOffDate">
                <div v-if="this.isOldCustomer" class="mb-4">
                    <p class="text-sm m-0" v-bind:style="{ textIndent: '20px' }">
                        โปรดยืนยันตัวตนของท่านเพื่อเปิดใช้งานระบบ Wallet เนื่องจากระบบจะปรับการใช้งานส่วนการชำระเงิน จากการออกใบแจ้งหนี้ เป็นระบบ Wallet
                    </p>
                    <p class="text-sm m-0" v-bind:style="{ textIndent: '20px' }">
                        กรุณายืนยันข้อมูลเพื่อเปิดใช้งานระบบ Wallet ก่อนวันที่ {{ this.formattedDate }} หากไม่ยืนยันจะส่งผลให้ท่านไม่สามารถใช้งานระบบต่อได้ <span v-if="this.role.member" class="text-red text-decoration-underline">&nbsp;โปรดแจ้งเจ้าของร้านเพื่อดำเนินการตามวิธีด้านล่าง</span>
                    </p>
                </div>
    
                <div v-if="!this.isOldCustomer" class="mb-4">
                    <p class="text-sm m-0" v-bind:style="{ textIndent: '20px' }">
                        กรุณาดำเนินการยืนยันตัวตนเพื่อเปิดใช้ Wallet ก่อนการใช้งาน โดยระบบจะส่งลิงก์ไปที่ Email ด้านล่าง <span v-if="this.role.member" class="text-red text-decoration-underline">&nbsp;โปรดแจ้งเจ้าของร้านเพื่อดำเนินการตามวิธีด้านล่าง</span>
                    </p>
                </div>
    
                <p class="text-sm m-0">1. กดปุ่มยืนยันเพื่อรับลิงก์ยืนยันตัวตนผ่านอีเมล</p>
                <p class="text-sm m-0">2. กดลิงก์ในอีเมลที่ระบบส่งให้</p>
                <p class="text-sm m-0">3. ตรวจสอบและยืนยันข้อมูลตามที่ระบบ</p>
                <p class="text-sm m-0">4. เมื่อยืนยันการเปิดใช้งานสำเร็จแล้ว ดำเนินการเติมเงินและใช้งานได้ทันที</p>
             </div>
 
             <div class="d-flex flex-column justify-content-center align-items-center mt-4">
                <div class="form-group w-75">
                    <label>Email</label>
                    <div class="d-flex">
                        <input type="email" class="form-control" :disabled="!this.enableEdit || this.loading || this.isSuccess || !this.role.admin" :value="this.email" @change="handleChange">
                        <div v-if="this.role.admin" class="ml-3 cursor-pointer align-items-center justify-content-center" @click="handleEnableEdit" v-bind:style="{ display: !this.enableEdit ? 'flex' : 'none'  }">
                            <Icon icon="mage:pen" v-bind:style="{ color: this.$THEME.backgroundColor, fontSize: '24px' }"/>
                        </div>
                    </div>
                </div>
                 <b-button v-if="this.role.admin" size="sm" class="w-25" block variant="primary" @click="handleSubmit" v-bind:disabled="this.loading">ยืนยัน</b-button>
             </div>
             <div v-if="this.message" class="text-center mt-2" v-bind:style="{ color: this.isSuccess ? 'green' : 'red' }">{{ this.message }}</div>
         </div>
     </b-modal>
    </div>
 </template>
 
 <script>
     import lsm from '@/constants/LocalStorageManagement'
     import moment from 'moment'
     import { fetchShopMetadataToLocalStorage, fetchWalletMetadataToLocalStorage } from '@/axios/walletPayment'
 
     export default {
         name: 'VerifyWalletModal',
         data() {
             return {
                 email: '',
                 name: '',
                 open: false,
                 message: '',
                 isSuccess: false,
                 isOldCustomer: false,
                 formattedDate: '',
                 loading: false,
                 enableEdit: false,
                 isExceedCutOffDate: false,
                 role: {
                     admin: false,
                     member: false
                 }
             }
         },
         methods: {
             closeModal() {
                 this.open = false
                 this.email = ''
                 this.name = ''
                 this.message = ''
                 this.enableEdit = false
                 this.isExceedCutOffDate = false
             },
             handleChange(e) {
                 this.email = e.target.value
             },
             handleEnableEdit() {
                this.enableEdit = true
             },
             getShopMetadata() {
                 const shopMetaData = lsm.shopMetadata().get()
 
                 const createdAt = shopMetaData.shop_metadata ? shopMetaData.shop_metadata.created_at : null
                 const launchedAt = shopMetaData.shop_metadata ? shopMetaData.shop_metadata.walletv2_launched_date : null
                 const ownerName = shopMetaData.shop_metadata ? shopMetaData.shop_metadata.owner_name : ''
 
                 return { createdAt, launchedAt, ownerName }
             },
             handleShouldOpen(values) {
                 this.email = values.email
                 this.isOldCustomer = values.isOldCustomer
                 this.formattedDate = values.formattedDate
                 this.open = true
                 this.name = values.name
             },
             handleIsExceedCutOffDate(date) {
                const now = moment().format('YYYY-MM-DD HH:mm:ss')
                const launchedAt = moment(date).format('YYYY-MM-DD HH:mm:ss')
    
                return moment(now).isAfter(launchedAt)
             },
             async openModal(option = null) {
                 const allowThemes = ['shippop']
                 const isPOS = option ? option.isPOS : false
                 
                 if (!process.env.VUE_APP_MEMBER_SERVICE_API || !allowThemes.includes(this.$THEME.name)) {
                     return null
                 }

                 moment.locale('th')
                 
                 const walletMetaData = lsm.walletMetadata().get()
                 let shopMetadata = this.getShopMetadata()

                 if (!shopMetadata.createdAt || !shopMetadata.launchedAt) {
                    await fetchShopMetadataToLocalStorage()

                    shopMetadata = this.getShopMetadata()
                 }

                 this.isExceedCutOffDate = this.handleIsExceedCutOffDate(shopMetadata.launchedAt)
                 
                 const email = walletMetaData.wallet_metadata ? walletMetaData.wallet_metadata.email : ''
                 const verifed = walletMetaData.wallet_metadata ? walletMetaData.wallet_metadata.verified : 0
                 const enabled = walletMetaData.wallet_metadata ? walletMetaData.wallet_metadata.enabled : 0
                 const isAdmin = this.$USER_LOGIN.get().isAdmin
                 const isMember = this.$USER_LOGIN.get().isMember
 
                 const shouldOpen = (isAdmin || isMember) && email && !verifed && enabled && (!this.isExceedCutOffDate || isPOS)
 
                 this.role.admin = isAdmin
                 this.role.member = isMember

                 if (shouldOpen) {
                    this.handleShouldOpen({
                        email,
                        isOldCustomer: moment(shopMetadata.createdAt).isBefore(shopMetadata.launchedAt),
                        formattedDate: moment(shopMetadata.launchedAt).add(543, 'year').format('D MMMM YYYY'),
                        name: shopMetadata.ownerName
                    })
                 } 
             },
             async handleUpdateWalletAccountEmail() {
                const url = `${process.env.VUE_APP_API}/shop_wallet/update_email`
                const accessToken = localStorage.getItem('access_token')

                await this.$http.post(url, {
                    email: this.email
                }, {
                    headers: {
                        'Content-Type': 'application/json',
                        Token: accessToken
                    }
                }).then(res => {
                    if (!res.data.status) {
                        throw new Error(this.mapErrorMessage(res.data.error));
                    }
                }).catch(err => {
                    if (err.response) {
                        throw new Error(this.mapErrorMessage(err.response.data.error))
                    } else {
                        throw new Error(err.message)
                    }
                })
             },
             async handleSubmitVerification() {
                 const url = `${process.env.VUE_APP_MEMBER_SERVICE_API}/verification`
  
                 await this.$http.post(url, {
                     email: this.email,
                     name: this.name,
                     platform: 'POPSHOP',
                     scope: ['email', 'phone'],
                     consent: ['wallet_popshop'],
                     callbackUrl: `${window.location.origin}/callback/wallet-verification`,
                     action: 'wallet_verification'
                 }).then(res => {
                     if (res.data.status) {
                         this.message = 'ระบบส่งข้อมูลแล้ว กรุณาตรวจสอบที่ Email'
                     } else {
                        throw new Error(this.mapErrorMessage(res.data.message))
                    }
                 }).catch(err => {
                     if (err.response) {
                         throw new Error(this.mapErrorMessage(err.response.data.message))
                     } else {
                         throw new Error(err.message)
                     }
                 })
             },
             async handleFetchWalletMetadata() {
                 await fetchWalletMetadataToLocalStorage(true)
             },
             async handleSubmit() {
                this.loading = true
                this.message = ''

                try {
                    await this.handleUpdateWalletAccountEmail()
                    await this.handleFetchWalletMetadata()
                    await this.handleSubmitVerification()

                    this.isSuccess = true
                } catch (error) {
                    this.isSuccess = false
                    this.message = error.message
                } finally {
                    this.loading = false
                }
             },
             mapErrorMessage(key) {
                 switch (key) {
                     case 'member_not_found':
                         return 'ไม่พบข้อมูลสมาชิก'
                     case 'email already verified':
                         return 'อีเมลนี้ถูกเปิดใช้งาน Wallet แล้ว'
                     case 'email already exist in another shop':
                         return 'อีเมลนี้ถูกใช้งานในร้านค้าอื่นแล้ว'   
                     default:
                         return key
                 }
             }
         }
     }
 </script>